// extracted by css-extract-rspack-plugin
export default {"Box":"selected-repository-pill-module__Box__e7kg95k","Text":"selected-repository-pill-module__Text__AI9kCY1","Text_1":"selected-repository-pill-module__Text_1__VbbFpl2"};